import React, {useEffect, useState} from 'react';
import {
    Alert,
    Button,
    Col,
    ConfigProvider,
    Form,
    Input,
    Modal,
    Row,
    Table,
    Tag,
    Upload,
    UploadFile,
    UploadProps
} from 'antd';
import Colors from "../../../styles/Colors";
import {BiCheck, BiX} from "react-icons/bi";
import 'dayjs/locale/es';
import locale from "antd/es/locale/es_ES";
import {ColumnsType, TableProps} from "antd/es/table";
import AlumneCasal from "../../../model/inscripcions/AlumneCasal";
import {useParams} from "react-router-dom";
import {InboxOutlined} from "@ant-design/icons";
import {PostInscripcioIdAlumneId} from "../../../dao/inscripcions/PostInscripcioIdAlumneId";
import {BsEye} from "react-icons/bs";
import {GetInscripcionsIdActivitatsIdDocuments} from "../../../dao/inscripcions/GetInscripcionsIdActivitatsIdDocuments";
import Document from "../../../model/inscripcions/Document";
import {
    GetInscripcionsIdActivitatsIdDescarregues
} from "../../../dao/inscripcions/GetInscripcionsIdActivitatsIdDescarregues";
import FileListDetail from "../../../model/inscripcions/FileListDetail";
import {randomInt} from "node:crypto";
import {GetInscripcionsIdDocumentsIdDownload} from "../../../dao/inscripcions/GetInscripcionsIdDocumentsIdDownload";
import toast from "react-hot-toast";
import {GetInscripcionsIdAlumneIdDocuments} from "../../../dao/inscripcions/GetInscripcionsIdAlumneIdDocuments";
import {PostInscripcionsAlumneDownload} from "../../../dao/inscripcions/PostInscripcionsAlumneDownload";

interface PagadorModalProps {
    element: any; // Cambiado a tipo any para aceptar cualquier tipo de elemento
    visible: boolean;
    page: string,
    onClose: (value: boolean) => void,
    documents: UploadFile[],
    idInsc: string,
}

const DocumentacioModal: React.FC<PagadorModalProps> = ({element, visible, onClose, page, documents, idInsc}) => {
    const [form] = Form.useForm();
    const [options, setOptions] = useState<UploadFile[]>([]);
    const [isSend, setIsSend] = useState(false);

    const [loading, setLoading] = useState(false);

    useEffect(() => {

    }, [idInsc]);
    async function handleSubmit () {
        setIsSend(true);
        const formData = form.getFieldsValue();

        console.log("Form Data con setmanes reorganizados:", formData);
        console.log(JSON.stringify(formData));
        await PostInscripcioIdAlumneId(idInsc+"", element.id_alumne_casal+"", page, formData);
        onClose(true);
        setIsSend(false);
    };


    const handleCancel = () => {
        onClose(false);
    };

    async function downloadFile(file: any) {
        const json = await PostInscripcionsAlumneDownload(idInsc+"", element.id_alumne_casal, file, page);
        window.open(json.url, '_blank');
        /*const blob = await GetInscripcionsIdDocumentsIdDownload(idInsc+"", file.uid, page);
        if (blob && blob.size > 0) {
            const url = window.URL.createObjectURL(new Blob([blob]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', file.name);
            document.body.appendChild(link);
            link.click();
            window.URL.revokeObjectURL(url);
        } else {
            toast.error("Fitxer no trobat...");
        }*/
    }

    const props2: UploadProps = {
        showUploadList: {
            showDownloadIcon: true,
            downloadIcon: 'Visualitzar',
            showRemoveIcon: false,
        },
        onDownload: downloadFile
    };

    return (
        <ConfigProvider locale={locale}>
        <Modal
            title="DOCUMENTS"
            visible={visible}
            onCancel={handleCancel}
            footer={[]}
            maskClosable={false}
            width={"80%"}
        >
            <hr/>
            <Form.Item label={"ID usuari"}><Input disabled={true} value={element.id_alumne_casal}/></Form.Item>
            <Form form={form} initialValues={element} onFinish={handleSubmit}>
                <Row gutter={[16, 16]}>
                    <Col span={24}>
                        <Upload {...props2}
                            //action="https://660d2bd96ddfa2943b33731c.mockapi.io/api/upload"
                            listType="picture"
                            defaultFileList={[...documents]}
                        >
                        </Upload>
                    </Col>
                </Row>
                <hr/>
                <Row gutter={[16, 16]}>
                    <Col span={2}>
                        <Button title={"Cancelar"} style={{backgroundColor: Colors.colors.color3}}
                                onClick={handleCancel}><BiX/> TANCAR</Button>
                    </Col>
                </Row>
            </Form>
        </Modal>
        </ConfigProvider>
    );
};

export default DocumentacioModal;
